import React, { createContext, useContext, useState } from "react";

function PublicEventsProvider(props) {
    const [publicSaveEvent, setPublicSaveEvent] = useState(undefined)
    const [publicCancelEvent, setPublicCancelEvent] = useState(undefined)
    const [publicAddEvent, setPublicAddEvent] = useState(undefined)
    
    const [publicDirty, setPublicDirty] = useState(undefined)
    const [publicReadOnly, setPublicReadonly] = useState(undefined) 
    const [publicActivePageInfo, setPublicActivePageInfo] = useState(undefined)

    return (
        <PublicEventsContext.Provider value={{
            publicSaveEvent, setPublicSaveEvent,
            publicDirty, setPublicDirty,
            publicReadOnly, setPublicReadonly,
            publicCancelEvent, setPublicCancelEvent,
            publicAddEvent, setPublicAddEvent,
            publicActivePageInfo, setPublicActivePageInfo
        }} {...props} />
    );

}

const PublicEventsContext = createContext({})
const usePublicEvents = () => useContext(PublicEventsContext)

export { PublicEventsProvider, usePublicEvents }